import { groupsQueryKeys } from './query-keys.utils'
import type { InfiniteData, QueryClient } from '@tanstack/vue-query'

import type { GroupResponse } from '../services/groups.service'
import type { IGroup } from '../types/types'

export interface ResolvedGroupNameFromCache {
  name: string
  groupId?: string
}

/**
 * Read-only group display name from TanStack Query caches (groups list, then groupBySlug).
 * Used by breadcrumb composables to avoid a loading flash when caches are already warm.
 */
export function resolveGroupNameFromCache(queryClient: QueryClient, groupSlug: string): ResolvedGroupNameFromCache | null {
  if (process.server || !groupSlug) return null

  const listData = queryClient.getQueryData(groupsQueryKeys.groups()) as InfiniteData<IGroup[]> | undefined
  if (listData?.pages) {
    const match = listData.pages.flat().find((g: IGroup) => g.slug === groupSlug)
    const listName = match?.name?.trim()
    if (listName && listName.length > 0) {
      return { name: listName, groupId: match?._id }
    }
  }

  const bySlug = queryClient.getQueryData(groupsQueryKeys.groupBySlug(groupSlug)) as GroupResponse | undefined
  const detailName = bySlug?.groupDetail?.name?.trim()
  if (detailName && detailName.length > 0) {
    return { name: detailName, groupId: bySlug?.groupDetail?._id }
  }

  return null
}
